import { formattedDate } from "./Utils"

export const PatientProfile = ({patientDetails}) => {
    return <><div className="mt-6 xl:mt-0 bg-white dark:bg-slate-900 rounded-xl shadow-md border dark:border-slate-800 overflow-hidden">
            {/* Header */}
            <div className="relative bg-gradient-to-r from-green-500 to-emerald-600 p-5 flex flex-col items-center text-white">
              {/* Avatar + Badge Wrapper */}
              <div className="relative">
                <img
                  src="/images/patient-avatar.jpg"
                  alt="Patient Avatar"
                  className="w-24 h-24 rounded-full border-4 border-white object-cover shadow-lg"
                />

                {/* OPD / ICU Badge */}
                <div
                  className={`absolute -bottom-2 -right-6 px-2 py-1 rounded-full text-[10px] font-semibold shadow-md
                   ${patientDetails?.patient_type === "icu"
                      ? "bg-red-600 text-white"
                      : "bg-green-600 text-white"
                    }`}
                >
                  <div className="flex items-center uppercase gap-1">
                    {/* Small medical icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      className="w-3 h-3"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 3v18m9-9H3"
                      />
                    </svg>

                    {patientDetails?.patient_type ?? "N/A"}
                  </div>
                </div>
              </div>

              {/* Name */}
              <h3 className="mt-3 text-sm font-semibold">{patientDetails?.patient_name ?? "N/A"} {patientDetails?.father_husband_name ?? "N/A"}</h3>

              <p className="text-xs opacity-90">Patient Profile</p>
            </div>

            {/* Body */}
            <div className="p-5 space-y-4 text-sm">
              <div className="flex justify-between border-b pb-2 dark:border-slate-700">
                <span className="text-gray-500">Gender</span>
                <span className="font-medium text-gray-800 dark:text-gray-200">
                  {patientDetails?.gender ||  "N/A"}
                </span>
              </div>

              <div className="flex justify-between border-b pb-2 dark:border-slate-700">
                <span className="text-gray-500">Age</span>
                <span className="font-medium text-gray-800 dark:text-gray-200">
                  {`${ patientDetails?.age ? (patientDetails?.age + 'yrs') : "N/A"} `} 
                </span>
              </div>

              <div className="flex justify-between border-b pb-2 dark:border-slate-700">
                <span className="text-gray-500">Date of Birth</span>
                <span className="font-medium text-gray-800 dark:text-gray-200">
                  {formattedDate(patientDetails?.dob) || "N/A"}
                </span>
              </div>

              <div className="flex justify-between border-b pb-2 dark:border-slate-700">
                <span className="text-gray-500">Phone</span>
                <span className="font-medium text-gray-800 dark:text-gray-200">
                  {patientDetails?.mobile || "N/A"}
                </span>
              </div>

              <div className="flex justify-between border-b pb-2 dark:border-slate-700">
                <span className="text-gray-500">Unit-District</span>
                <span className="font-medium text-gray-800 dark:text-gray-200">
                  {`${patientDetails?.unit_name || "N/A"} - ${patientDetails?.district_name||"N/A"}`}
                </span>
              </div>

              <div className="flex justify-between">
                <span className="text-gray-500">CNIC</span>
                <span className="font-medium text-gray-800 dark:text-gray-200">
                  {patientDetails?.patient_cnic || "N/A"}
                </span>
              </div>
            </div>
          </div></>
}
